export const defaultEntity = "opere";
export const entities = ["opere", "opera"];
export const labels = {
  opere: "Opere",
  opera: "Opera",
};
